<template>
  <div class="menu ld-background ld-right-slide ld-scroll-y">
    <v-layout class="px4" wrap>
      <v-flex class="ld-menu-nav-container">
        <navigation-menu-component
          class="ld-scroll-none"
          @onClickNav1="onClickNav1"
          @onClickNav2="onClickNav2"
          @onClickNav3="onClickNav3"
          @onClickNav4="onClickNav4"
        ></navigation-menu-component>
      </v-flex>
      <v-flex class="ld-menu-text-title-container" xs12>
        <div class="ld-menu-text-title mt-3 pl-3">Menu Page</div>
      </v-flex>
      <div class="ld-menu-slide-container">
        <div class="ld-menu-slide-carousel">
          <div class="ld-menu-slide" :style="{'transform': slide1Translate, 'transition': slideTransformDuration}">
            <!-- Milk tea -->
            <v-layout row wrap class="mt-3 pl-3">
              <v-flex xs12>
                <div class="ld-menu-text-header">Milk Tea</div>
              </v-flex>
              <v-flex
                v-for="(flavor, index) in milkTeaFlavorColumns"
                class="ld-menu-text-container"
                :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
                <div class="ld-menu-text">{{ flavor.flavor }}</div>
                <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
                <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
                <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
              </v-flex>
              <v-flex xs12 class="ld-menu-text-container mt-1">
                <div class="ld-inline ld-menu-favorite">Favorite
                  <v-icon class="ld-menu-favorite">favorite</v-icon>
                </div>
                <div class="ld-inline ld-menu-dairy mx-3">Contains Dairy (D)</div>
                <div class="ld-inline ld-menu-premium">Premium (P)</div>
              </v-flex>
            </v-layout>
          </div><!-- Comment out the white space to remove added spacing between divs when using display:inline-block
       --><div class="ld-menu-slide" :style="{'transform': slide3Translate, 'transition': slideTransformDuration}">
            <!-- Iced tea -->
            <v-layout row wrap class="mt-3 pl-3">
              <v-flex xs12>
                <div class="ld-menu-text-header">Iced Tea</div>
              </v-flex>
              <v-flex xs12>
                <div class="body-2 ld-menu-text ld-menu-regular my-1">Made with a choice of: Black, Jasmine, or Oolong
                  tea
                </div>
              </v-flex>
              <v-flex
                v-for="(flavor, index) in icedTeaFlavorColumns"
                class="ld-menu-text-container"
                :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
                <div class="ld-menu-text">{{ flavor.flavor }}</div>
                <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
                <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
                <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
              </v-flex>
              <v-flex xs12 class="ld-menu-text-container mt-1">
                <div class="ld-inline ld-menu-favorite">Favorite
                  <v-icon class="ld-menu-favorite">favorite</v-icon>
                </div>
                <div class="ld-inline ld-menu-dairy mx-3">Contains Dairy (D)</div>
                <div class="ld-inline ld-menu-premium">Premium (P)</div>
              </v-flex>
            </v-layout>
          </div><!-- Comment out the white space to remove added spacing between divs when using display:inline-block
       --><div class="ld-menu-slide" :style="{'transform': slide2Translate, 'transition': slideTransformDuration}">
          <!-- Snow bubble or slush -->
          <v-layout row wrap class="mt-3 pl-3">
            <v-flex xs12>
              <div class="ld-menu-text-header">Snow Bubble or Slush</div>
            </v-flex>
            <v-flex
              v-for="(flavor, index) in slushAndSnowFlavorColumns"
              class="ld-menu-text-container"
              :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
              <div class="ld-menu-text">{{ flavor.flavor }}</div>
              <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
              <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
              <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
            </v-flex>
            <v-flex xs12 class="ld-menu-text-container mt-1">
              <div class="ld-inline ld-menu-favorite">Favorite
                <v-icon class="ld-menu-favorite">favorite</v-icon>
              </div>
              <div class="ld-inline ld-menu-dairy mx-3">Contains Dairy (D)</div>
              <div class="ld-inline ld-menu-premium">Premium (P)</div>
            </v-flex>
          </v-layout>
        </div><!-- Comment out the white space to remove added spacing between divs when using display:inline-block
       --><div class="ld-menu-slide" :style="{'transform': slide4Translate, 'transition': slideTransformDuration}">
            <!-- Add-ins -->
            <v-layout row wrap class="mt-3 pl-3">
              <v-flex xs12>
                <div class="ld-menu-text-header">Add-ins</div>
              </v-flex>
              <!-- Boba -->
              <v-flex class="ld-menu-text-container" xs12>
                <div class="ld-menu-text-header-2 mt-2">Boba <v-icon class="ld-menu-favorite">favorite</v-icon></div>
                <div class="ld-menu-text-regular my-1">Also known as “tapioca balls” or “pearls”, boba originated in
                  Taiwan and are made of the starch derived from cassava root. When prepared perfectly, boba becomes
                  sweet, chewy, and translucent with a gummy bear-like texture.
                </div>
              </v-flex>
              <!-- Poppers -->
              <v-flex xs12 class="mt-3">
                <div class="ld-menu-text-header-2 mt-2">Poppers</div>
                <div class="ld-menu-text-regular my-1">Originating in Asia, popping pearls (also known as “popping boba”
                  or “bursting boba”) are a beverage sensation trending in mainstream Europe. Each popping pearl is
                  about 3/8” in diameter and bursts with flavorful fruit juices when bitten into.
                </div>
              </v-flex>
              <v-flex
                v-for="(flavor, index) in popperFlavorColumns"
                class="ld-menu-text-container"
                :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
                <div class="ld-menu-text">{{ flavor.flavor }}</div>
                <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
                <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
                <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
              </v-flex>
              <!-- Jellies -->
              <v-flex xs12 class="mt-3">
                <div class="ld-menu-text-header-2 mt-2">Jellies</div>
                <div class="ld-menu-text-regular my-1">Jelly and other toppings add extra fun and flavor into your
                  beverage. Whether it's coffee jelly in your milk tea, three color jelly or an assortment of jellies
                  in your slush, or mango jelly in your fruit tea, Lollicup offers a variety of jellies that will
                  sweeten any beverage.
                </div>
              </v-flex>
              <v-flex
                v-for="(flavor, index) in jellyFlavorColumns"
                class="ld-menu-text-container"
                :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
                <div class="ld-menu-text">{{ flavor.flavor }}</div>
                <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
                <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
                <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
              </v-flex>
              <!-- Puddings -->
              <v-flex xs12 class="mt-3">
                <div class="ld-menu-text-header-2 mt-2">Pudding</div>
                <div class="ld-menu-text-regular my-1">Flavored pudding is a flan textured custard that can be added into
                  any beverage. Enjoy your favorite milk tea with one or a combination of chocolate, eggnog, taro,
                  milk, or all four great pudding flavors.
                </div>
              </v-flex>
              <v-flex
                v-for="(flavor, index) in puddingFlavorColumns"
                class="ld-menu-text-container"
                :class="getFlavorClass()" :key="index + '-' + flavor.flavor">
                <div class="ld-menu-text">{{ flavor.flavor }}</div>
                <div v-if="flavor.dairy === true" class="ld-menu-dairy">D</div>
                <div v-if="flavor.premium === true" class="ld-menu-premium">P</div>
                <v-icon v-if="flavor.favorite === true" class="ld-menu-favorite">favorite</v-icon>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
  import IcedTeaFlavors from '../js/iced_tea_flavors';
  import JellyFlavors from '../js/jelly_flavors';
  import MilkTeaFlavors from '../js/milk_tea_flavors';
  import NavigationMenuComponent from './navigation_menu_component.vue';
  import PopperFlavors from '../js/popper_flavors';
  import PuddingFlavors from '../js/pudding_flavors';
  import SlushAndSnowFlavors from '../js/slush_and_snow_flavors';
  export default {

    components: {
      NavigationMenuComponent
    },

    methods: {
      getFlavorClass: function() {
        let returnClass;

        if (this.screenWidthSmall) {
          returnClass = ' xs6';
        } else {
          returnClass = ' xs4';
        }
        return returnClass;
      },

      getFlavorColumns: function(flavors, numberOfColumns) {
        let buildColumns = {};
        let i;
        let ii;
        let returnBuildColumns = [];
        const FLAVORS = flavors || [];
        const TOTAL_COLUMNS = numberOfColumns;
        const TOTAL_FLAVORS = FLAVORS.length;
        const TOTAL_PER_COLUMN = Math.floor(TOTAL_FLAVORS / TOTAL_COLUMNS);
        const TOTAL_LAST_COLUMNS = TOTAL_FLAVORS % TOTAL_COLUMNS;
        const IS_OFFSET = (TOTAL_LAST_COLUMNS > 0);
        let offset;

        // Make sure the child objects exist to set data into
        for (i = 0;i < TOTAL_COLUMNS;i++) {
          buildColumns[i] = {};
        }

        for (i = 0;i < TOTAL_PER_COLUMN;i++) {
          // Reset the offset on the start of each row.
          offset = 0;
          for (ii = 0;ii < TOTAL_COLUMNS;ii++) {
            if (typeof FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)] !== 'undefined') {
              buildColumns[ii][i] = FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)];
              // Offset starts at 0 to not offset the first column. If 'IS_OFFSET' is true, then there is an offset to
              // all columns after the first. Only increment up to one less than the 'TOTAL_LAST_COLUMNS' to offset
              // each incremented column by the last incremented offset value. Total offset will increase by the number
              // of cells shifted. If no more cells shift, the offset will not increment. Offset is when there is a
              // difference in number of flavors per column, 'offset = (flavors % columns > 0)'. Makes sense right?
              if (IS_OFFSET && offset < TOTAL_LAST_COLUMNS) {
                ++offset;
              }
            } else {
              // In order to fill the empty space on the DOM to represent the offset, add an empty element to the
              // 'buildColumns' array when an undefined is found during iterations.
              buildColumns[ii][i] = '';
            }
          }
        }

        // Total columns is the number of columns that will have an extra element after the final iteration of the
        // above for-loop. This was implemented to prevent the columns from overlapping values.
        if (TOTAL_LAST_COLUMNS > 0) {
          // Reset the offset for the final row
          offset = 0;
          // 'i' is already incremented from the previous for-loop, use 'i' at it's current value to get the final
          // elements from the 'FLAVORS' array.
          for (ii = 0;ii < TOTAL_LAST_COLUMNS;ii++) {
            if (typeof FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)] !== 'undefined') {
              buildColumns[ii][i] = FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)];
              // Offset starts at 0 to not offset the first column. If 'IS_OFFSET' is true, then there is an offset to
              // all columns after the first. Only increment up to one less than the 'TOTAL_LAST_COLUMNS' to offset
              // each incremented column by the last incremented offset value. Total offset will increase by the number
              // of cells shifted. If no more cells shift, the offset will not increment. Offset is when there is a
              // difference in number of flavors per column, 'offset = (flavors % columns > 0)'. Makes sense right?
              if (IS_OFFSET && offset < TOTAL_LAST_COLUMNS) {
                ++offset;
              }
            } else {
              // In order to offset the empty space, add an empty element to the 'buildColumns' array.
              buildColumns[ii][i] = '';
            }
          }
        }

        // Rebuild the final array that will be used as the v-for array to build the slush and snow menu.
        for (i = 0;i <= TOTAL_PER_COLUMN;i++) {
          for (ii = 0;ii < TOTAL_COLUMNS;ii++) {
            if (typeof buildColumns[ii][i] !== 'undefined') {
              returnBuildColumns.push(buildColumns[ii][i]);
            }
          }
        }

        // Total last columns is the number of columns that will have an extra element after the final iteration of the
        // above for-loop.
        if (TOTAL_LAST_COLUMNS > 0) {
          // 'i' is already incremented from the previous for-loop, use 'i' at it's current value to get the final
          // elements from the 'buildColumns' array.
          for (ii = 0;ii < TOTAL_LAST_COLUMNS;ii++) {
            if (typeof buildColumns[ii][i] !== 'undefined') {
              returnBuildColumns.push(buildColumns[ii][i]);
            }
          }
        }
        return returnBuildColumns;
      },

      /**
       * onClickNav1 will listen for the click event of the first navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav1: function() {
        this.transitionSlides(1);
      },

      /**
       * onClickNav2 will listen for the click event of the second navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav2: function() {
        this.transitionSlides(2);
      },

      /**
       * onClickNav3 will listen for the click event of the third navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav3: function() {
        this.transitionSlides(3);
      },

      /**
       * onClickNav4 will listen for the click event of the fourth navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav4: function() {
        this.transitionSlides(4);
      },

      /**
       * transitionSlides will set the slide transition values appropriately, determined by the argument provided.
       * @param navDestination - integer - the navigation button clicked.
       */
      transitionSlides: function(navDestination) {
        switch (navDestination) {
          case 1:
            this.slide1Translate = 'translate(0, 0)';
            this.slide2Translate = 'translate(0, 0)';
            this.slide3Translate = 'translate(0, 0)';
            this.slide4Translate = 'translate(0, 0)';
            break;

          case 2:
            this.slide1Translate = 'translate(-100%, 0)';
            this.slide2Translate = 'translate(-100%, 0)';
            this.slide3Translate = 'translate(-100%, 0)';
            this.slide4Translate = 'translate(-100%, 0)';
            break;

          case 3:
            this.slide1Translate = 'translate(-200%, 0)';
            this.slide2Translate = 'translate(-200%, 0)';
            this.slide3Translate = 'translate(-200%, 0)';
            this.slide4Translate = 'translate(-200%, 0)';
            break;

          case 4:
            this.slide1Translate = 'translate(-300%, 0)';
            this.slide2Translate = 'translate(-300%, 0)';
            this.slide3Translate = 'translate(-300%, 0)';
            this.slide4Translate = 'translate(-300%, 0)';
            break;

          default:
            this.slide1Translate = 'translate(0, 0)';
            this.slide2Translate = 'translate(0, 0)';
            this.slide3Translate = 'translate(0, 0)';
            this.slide4Translate = 'translate(0, 0)';
            break;
        }
      }
    },

    name: 'menuComponent',

    props: ['screenWidthSmall'],

    watch: {
      screenWidthSmall(value) {
        const NUMBER_OF_COLUMNS = (value) ? 2 : 3;
        this.icedTeaFlavorColumns = this.getFlavorColumns(IcedTeaFlavors.data, NUMBER_OF_COLUMNS);
        this.jellyFlavorColumns = this.getFlavorColumns(JellyFlavors.data, NUMBER_OF_COLUMNS);
        this.milkTeaFlavorColumns = this.getFlavorColumns(MilkTeaFlavors.data, NUMBER_OF_COLUMNS);
        this.popperFlavorColumns = this.getFlavorColumns(PopperFlavors.data, NUMBER_OF_COLUMNS);
        this.puddingFlavorColumns = this.getFlavorColumns(PuddingFlavors.data, NUMBER_OF_COLUMNS);
        this.slushAndSnowFlavorColumns = this.getFlavorColumns(SlushAndSnowFlavors.data, NUMBER_OF_COLUMNS);
      }
    },

    data() {
      return {
        icedTeaFlavorColumns: [],
        jellyFlavorColumns: [],
        milkTeaFlavorColumns: [],
        popperFlavorColumns: [],
        puddingFlavorColumns: [],
        slushAndSnowFlavorColumns: [],
        // Left slide initial configurations
        slide1Translate: 'translate(0, 0)',
        slide2Translate: 'translate(0, 0)',
        slide3Translate: 'translate(0, 0)',
        slide4Translate: 'translate(0, 0)',
        // Transform configurations
        slideTransformDuration: 'transform 1.5s'
      };
    },

    mounted() {
      const NUMBER_OF_COLUMNS = (this.screenWidthSmall) ? 2 : 3;
      this.icedTeaFlavorColumns = this.getFlavorColumns(IcedTeaFlavors.data, NUMBER_OF_COLUMNS);
      this.jellyFlavorColumns = this.getFlavorColumns(JellyFlavors.data, NUMBER_OF_COLUMNS);
      this.milkTeaFlavorColumns = this.getFlavorColumns(MilkTeaFlavors.data, NUMBER_OF_COLUMNS);
      this.popperFlavorColumns = this.getFlavorColumns(PopperFlavors.data, NUMBER_OF_COLUMNS);
      this.puddingFlavorColumns = this.getFlavorColumns(PuddingFlavors.data, NUMBER_OF_COLUMNS);
      this.slushAndSnowFlavorColumns = this.getFlavorColumns(SlushAndSnowFlavors.data, NUMBER_OF_COLUMNS);
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/menu_component.vue